export { InternetConnectivity as SystemInternetConnectivity } from './InternetConnectivity'
